export default "__VITE_ASSET__Dx5xH7Wq__"